var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-block"},[_c('span',[_vm._v("https://chat.top")]),_c('div',{staticClass:"copy-btn",attrs:{"data-clipboard-text":`https://chat.xiaoheihe.cn/app/?mini_pro_id=${_vm.mini_pro_id}`},on:{"click":_vm.copy}},[_vm._v("复制")])])
}
var staticRenderFns = []

export { render, staticRenderFns }